// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"352":"3a589860912abf67a995","971":"3a589860912abf67a995"}[chunkId] + ".css";
};